import {getAssetUrl} from '@Utils/s3.util';
import {LayeringType} from '@Libraries/layering-type';
import type {LayersVisualConfig} from '@Modals/ai-action-loading-modal/ai-action-loading-modal.types';
import type {LayersAnimationConfig, LayersAnimationTiming} from '@Components/editable-text-layers-visual/editable-text-layers-visual.types';
import {getLayerPoses, LayerRole, LayersLoopMode} from '@Components/editable-text-layers-visual/editable-text-layers-visual.types';

const MAKE_TEXT_EDITABLE_LAYERS_TIMING: LayersAnimationTiming = {
  toSeparated: {delayMs: 0, durationS: 2},
  toComposed: {delayMs: 0, durationS: 2},
};

export const MAKE_TEXT_EDITABLE_LOADER_ANIMATION: LayersAnimationConfig = {
  layers: [
    {role: LayerRole.BACKGROUND, imageUrl: getAssetUrl('ai-chat-editable-text-layers-music-fest-bg.webp'), poses: getLayerPoses({x: '12%', y: '-9%'})},
    {role: LayerRole.TEXT, imageUrl: getAssetUrl('ai-chat-editable-text-layers-music-fest-text.webp'), poses: getLayerPoses({x: '-11%', y: '16%'})},
  ],
  timing: MAKE_TEXT_EDITABLE_LAYERS_TIMING,
  loopMode: LayersLoopMode.SEAMLESS,
};

export const getMakeTextEditableLoadingTexts = (): string[] => {
  return [window.i18next.t('pmwjs_mte_preparing_design'), window.i18next.t('pmwjs_mte_layers_slight_changes')];
};

export const getMakeTextEditableLoadingTitle = (layeringType: LayeringType = LayeringType.TEXT): string => {
  if (layeringType === LayeringType.WITH_LAYERS) {
    return window.i18next.t('pmwjs_extracting_image_layers');
  }
  return window.i18next.t('pmwjs_extracting_text_layers');
};

export const getMakeTextEditableLayersVisualConfig = (layeringType: LayeringType = LayeringType.TEXT): LayersVisualConfig => {
  return {
    loadingTitle: getMakeTextEditableLoadingTitle(layeringType),
    readyTitle: window.i18next.t('pmwjs_mte_edit_design'),
    animation: MAKE_TEXT_EDITABLE_LOADER_ANIMATION,
  };
};
